import Vue from 'vue'
import Router from 'vue-router'

import HelloWorld from '@/components/HelloWorld'


Vue.use(Router)


export const constantRoutes =[
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/download/newest',
    component: (resolve) => require(['@/views/downloadNewestApp'], resolve),
  },
  {
    path: '/zhuce',
    component: (resolve) => require(['@/views/zhuce'], resolve),
  },
  {
    path: '/forgetPassword',
    component: (resolve) => require(['@/views/forgetPassword'], resolve),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/home',
    component: (resolve) => require(['@/views/home'], resolve),
    children:[
      {
        path:'/history',
        component:(resolve) => require(["@/views/realtime/historydata/history"],resolve),
        meta: {
          title: '历史数据'
        }
      },
      {
        path:'/xsqImportData',
        component:(resolve) => require(["@/views/export/xsq/xsqImportData"],resolve),
        meta: {
          title: '限速器数据导出'
        }
      },
      {
        path:'/phxsImportData',
        component:(resolve) => require(["@/views/export/phxs/phxsImportData"],resolve),
        meta: {
          title: '平衡系数数据导出'
        }
      },
      {
        path:'/ceLiangResult',
        component:(resolve) => require(["@/views/ceLiangResult"],resolve),
        meta: {
          title: '测量结果'
        }
      },
      {
        path:'/cameraRecordList',
        component:(resolve) => require(["@/views/cameraRecordList"],resolve),
        meta: {
          title: '视频列表'
        }
      },
      {
        path:'/userInfo',
        component:(resolve) => require(["@/views/userInfo"],resolve),
        meta: {
          title: '个人信息'
        }
      },
      // {
      //   path:'/showResult',
      //   component:(resolve) => require(["@/views/showResult"],resolve)
      // },

    ]
  }
]
export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js